"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Charts_1 = __importDefault(require("./Charts"));
const ChartCard_1 = __importDefault(require("./ChartCard"));
const ChartSection = ({ textColor, dataArray = [], bgColorArray }) => {
    return (react_1.default.createElement("div", { className: "w-full flex flex-wrap" }, dataArray.map((chartItem) => {
        const dataList = JSON.parse(chartItem.json_data);
        const labels = dataList.map((dataItem) => dataItem.label);
        const values = dataList.map((dataItem) => parseFloat(dataItem.value));
        const data = {
            labels: labels,
            datasets: [
                {
                    id: 1,
                    label: `${chartItem.subtitle}`,
                    backgroundColor: bgColorArray,
                    borderColor: `${chartItem.charttype === "line" ? [textColor] : ["#E2E8F0"]}`,
                    data: values,
                },
            ],
        };
        return (react_1.default.createElement(ChartCard_1.default, { key: chartItem.id, title: chartItem.title, subTitle: chartItem.subtitle, year: chartItem.year },
            react_1.default.createElement(Charts_1.default, { chartTitle: "", chartType: chartItem.charttype, data: data, options: {
                    plugins: {
                        legend: {
                            display: false,
                        },
                        title: {
                            display: false,
                        },
                    },
                } })));
    })));
};
exports.default = ChartSection;
